import type { ColumnsType } from 'antd/lib/table'
import { MyIntegrationsType } from '../models/myIntegrations.model'
import {
  FormLabels,
  CustomHeaderText,
  MyIntegrationActionColumn,
  UserIntegrationMovileViewColumn,
  MyIntegrationListPurchaseAmountColumn,
} from 'src/components'

const myIntegrationColumns: ColumnsType<MyIntegrationsType> = [
  {
    title: () => <CustomHeaderText text={'developers.Integration'} />,
    responsive: ['sm'],
    sorter: (a, b) => a.intergation_initial.length - b.intergation_initial.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return (
        <div style={{ marginBottom: '-10px' }}>
          <FormLabels
            title={record.intergation_initial}
            subtitle={record.integration_code}
          />
        </div>
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'developers.Usage'} />,
    responsive: ['sm'],
    sorter: (a, b) => a.purchase_amount - b.purchase_amount,
    sortDirections: ['descend', 'ascend'],
    render: (_, integration) => {
      return (
        <MyIntegrationListPurchaseAmountColumn
          symbol={integration.currency_symbol}
          amount={integration.purchase_amount}
          co2_amount={integration.compensated_amount}
        />
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered />,
    responsive: ['sm'],
    align: 'center',
    render: (_, record) => {
      return (
        <div style={{ left: '1rem' }}>
          <MyIntegrationActionColumn intergation_id={record.integration_id} />
        </div>
      )
    },
  },

  // Mobile VIew UserIntegrationMovileViewColumn
  {
    title: () => <CustomHeaderText text={'developers.Integration'} isCentered />,
    responsive: ['xs'],
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.intergation_initial.length - b.intergation_initial.length,
    render: (_, record) => <UserIntegrationMovileViewColumn integration={record} />,
  },
]

export default myIntegrationColumns
